import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const ImageIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <defs>
      <filter id="alpha" filterUnits="objectBoundingBox" x="0%" y="0%" width="100%" height="100%">
        <feColorMatrix type="matrix" in="SourceGraphic" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
      </filter>
      <mask id="mask0">
        <g filter="url(#alpha)">
          <rect
            x="0"
            y="0"
            width="24"
            height="24"
            fill="black"
            fillOpacity={0.501961}
            stroke="none"
          />
        </g>
      </mask>
      <clipPath id="clip1">
        <rect x="0" y="0" width="24" height="24" />
      </clipPath>
      <g id="surface5" clipPath="url(#clip1)">
        <path
          d="M 88.997396 118.359375 C 118.098958 118.359375 145.182292 111.979167 174.153646 111.979167 C 216.796875 111.979167 265.169271 111.979167 307.8125 111.979167 C 310.677083 111.979167 311.979167 174.283854 311.393229 186.71875 C 310.807292 200.976563 313.606771 275.911458 307.8125 285.286458 C 305.729167 288.606771 93.554688 289.192708 89.908854 285.286458 C 88.932292 284.244792 92.578125 154.752604 89.908854 140.104167 "
          transform="matrix(0.06,0,0,0.06,0,0)"
          fill="none"
          stroke="currentColor"
          strokeWidth={16}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={4}
          strokeOpacity={0.898039}
        />
      </g>
    </defs>
    <g>
      <use href="#surface5" mask="url(#mask0)" />
      <path
        d="M 125.195313 216.471354 C 130.46875 219.075521 129.882812 221.158854 146.354167 210.611979 C 149.544271 208.59375 166.276042 205.013021 169.270833 202.864583 C 177.213542 197.200521 184.830729 191.015625 192.122396 184.179688 C 201.888021 189.388021 208.984375 195.638021 213.411458 202.864583 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={16}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
      <path
        d="M 213.411458 209.505208 C 217.252604 203.450521 220.638021 200.260417 223.567708 200 C 227.539063 204.231771 230.664063 206.445313 232.877604 206.575521 C 240.299479 206.966146 237.695313 199.479167 245.703125 204.166667 C 256.380208 210.416667 262.565104 219.010417 275.390625 219.010417 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={16}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
      <path
        d="M 273.697917 241.471354 C 266.796875 241.601563 236.588542 234.635417 229.6875 236.132813 C 222.721354 237.565104 217.1875 251.106771 202.539063 246.549479 C 185.416667 241.276042 142.1875 238.020833 125.195313 241.861979 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={16}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
      <path
        d="M 232.747396 151.302083 C 272.981771 146.289062 232.747396 209.635417 220.963542 164.84375 C 219.140625 158.007812 226.432292 154.361979 230.664063 152.148438 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={16}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
    </g>
  </SvgIcon>
);

export default ImageIcon;
